import {Typography} from "antd";

const {Title} = Typography;

/**
 * One indicator, not four. The previous version ran a bouncing trophy, a pulsing
 * title, three staggered dots and a sliding bar at once, which reads as jitter
 * rather than progress.
 */
const DrawLoadingScreen = () => (
    <div
        className="min-h-screen flex items-center justify-center"
        style={{background: 'radial-gradient(120% 90% at 50% 0%, #241708 0%, #120C06 55%, #0A0704 100%)'}}
        role="status"
        aria-live="polite"
    >
        <div className="text-center">
            <div className="text-7xl mb-8" aria-hidden="true">🎉</div>

            <Title level={2} style={{color: 'var(--draw-gold-bright)'}}>
                Урамшуулал бэлдэж байна...
            </Title>

            <div className="w-64 h-2 rounded-full overflow-hidden mx-auto mt-6" aria-hidden="true" style={{background: 'rgba(232, 193, 112, 0.15)'}}>
                <div className="h-full bg-gradient-to-r from-[#A9762A] via-[#E8C170] to-[#FFDD97] animate-loading-bar"/>
            </div>
        </div>
    </div>
);

export default DrawLoadingScreen;
